const axios = require("axios");
const moment = require("moment");

const requestURL = "https://vriywyi9dg.execute-api.ap-northeast-1.amazonaws.com/v1/getCurrentWeather";

const getIndexOfDate = () => {
    // week day
    const whatDay = moment().format("d");
    let whatWeek;
    switch (Math.floor((moment().format("D") - 1) / 7)) {
        case 0:
            whatWeek = 0;
            break;
        case 1:
            whatWeek = 1;
            break;
        case 2:
            whatWeek = 2;
            break;
        case 3:
        case 4:
            whatWeek = 3;
            break;
        default:
    }

    return { whatWeek, whatDay };
};

const weather = {
    namespaced: true,
    state: {
        weatherData: [],
    },
    mutations: {
        initWeatherData(state) {
            console.log(`weather center: today is ${getIndexOfDate().whatWeek} week and the ${getIndexOfDate().whatDay} day of the week`);
            const today_fliprobot_weather = fliprobotData[getIndexOfDate().whatWeek][getIndexOfDate().whatDay];
            state.weatherData = [today_fliprobot_weather];
        },
        queryWeatherDataOnServer(state, payload) {
            state.weatherData = payload;
        }
    },
    actions: {
        queryWeatherDataOnServer({ commit }) {
            console.log("queryWeatherDataOnServer");

            axios
                .get(requestURL)
                .then((response) => {
                    const today_fliprobot_weather = fliprobotData[getIndexOfDate().whatWeek][getIndexOfDate().whatDay];
                    const weatherData = [today_fliprobot_weather]
                    for (let i = 0; i < 8; i += 1) {
                        const cityInfo = {};
                        cityInfo.name = response.data.Item.info.list[i].name;
                        cityInfo.weather = weatherClass[response.data.Item.info.list[i].weather[0].main];
                        const tempK = response.data.Item.info.list[i].main.temp;
                        cityInfo.temp_C = (tempK - 273).toFixed(1);
                        cityInfo.temp_F = ((tempK - 273) * (9 / 5) + 32).toFixed(1);
                        cityInfo.humidity = response.data.Item.info.list[i].main.humidity.toString();
                        // console.log(cityInfo.name, cityList.Taipei);
                        weatherData[cityList[cityInfo.name]] = cityInfo;
                    }
                    console.log("from axios: ", response, weatherData);
                    commit('queryWeatherDataOnServer', weatherData);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
    getters: {

        getWeatherData: (state) => (city, weatherType) => {
            console.log('get weather data'. city, weatherType)
            if (state.weatherData.length === 1){
                console.log('using local weather data');
                return state.weatherData[0][weatherInfoHexToString[weatherType]]
            }
            return state.weatherData[city][weatherInfoHexToString[weatherType]]
        }
    },
};


const fliprobotData = [
    [
        {
            weather: "0",
            temp_C: "27.8",
            temp_F: "82.0",
            humidity: "46",
            name: "FlipRobot",
        },
        {
            weather: "0",
            temp_C: "25.6",
            temp_F: "78.1",
            humidity: "39",
            name: "FlipRobot",
        },
        {
            weather: "1",
            temp_C: "21.3",
            temp_F: "70.3",
            humidity: "50",
            name: "FlipRobot",
        },
        {
            weather: "2",
            temp_C: "15.0",
            temp_F: "59.0",
            humidity: "85",
            name: "FlipRobot",
        },
        {
            weather: "2",
            temp_C: "13.5",
            temp_F: "56.3",
            humidity: "88",
            name: "FlipRobot",
        },
        {
            weather: "1",
            temp_C: "19.3",
            temp_F: "66.7",
            humidity: "65",
            name: "FlipRobot",
        },
        {
            weather: "0",
            temp_C: "25.5",
            temp_F: "77.9",
            humidity: "58",
            name: "FlipRobot",
        },
    ],
    [
        {
            weather: "1",
            temp_C: "19.9",
            temp_F: "67.8",
            humidity: "65",
            name: "FlipRobot",
        },
        {
            weather: "2",
            temp_C: "13.5",
            temp_F: "56.3",
            humidity: "74",
            name: "FlipRobot",
        },
        {
            weather: "2",
            temp_C: "15.8",
            temp_F: "60.4",
            humidity: "89",
            name: "FlipRobot",
        },
        {
            weather: "0",
            temp_C: "20.6",
            temp_F: "69.1",
            humidity: "39",
            name: "FlipRobot",
        },
        {
            weather: "1",
            temp_C: "19.5",
            temp_F: "67.1",
            humidity: "40",
            name: "FlipRobot",
        },
        {
            weather: "0",
            temp_C: "17.6",
            temp_F: "63.7",
            humidity: "56",
            name: "FlipRobot",
        },
        {
            weather: "2",
            temp_C: "18.2",
            temp_F: "64.8",
            humidity: "73",
            name: "FlipRobot",
        },
    ],
    [
        {
            weather: "2",
            temp_C: "31.5",
            temp_F: "88.7",
            humidity: "67",
            name: "FlipRobot",
        },
        {
            weather: "1",
            temp_C: "26.1",
            temp_F: "79.0",
            humidity: "72",
            name: "FlipRobot",
        },
        {
            weather: "0",
            temp_C: "29.8",
            temp_F: "85.6",
            humidity: "36",
            name: "FlipRobot",
        },
        {
            weather: "1",
            temp_C: "27.4",
            temp_F: "81.3",
            humidity: "60",
            name: "FlipRobot",
        },
        {
            weather: "0",
            temp_C: "31.3",
            temp_F: "88.3",
            humidity: "75",
            name: "FlipRobot",
        },
        {
            weather: "2",
            temp_C: "26.2",
            temp_F: "79.2",
            humidity: "66",
            name: "FlipRobot",
        },
        {
            weather: "1",
            temp_C: "27.1",
            temp_F: "80.8",
            humidity: "65",
            name: "FlipRobot",
        },
    ],
    [
        {
            weather: "1",
            temp_C: "23.0",
            temp_F: "73.4",
            humidity: "60",
            name: "FlipRobot",
        },
        {
            weather: "1",
            temp_C: "21.3",
            temp_F: "70.3",
            humidity: "50",
            name: "FlipRobot",
        },
        {
            weather: "0",
            temp_C: "20.6",
            temp_F: "69.1",
            humidity: "39",
            name: "FlipRobot",
        },
        {
            weather: "0",
            temp_C: "17.6",
            temp_F: "63.7",
            humidity: "56",
            name: "FlipRobot",
        },
        {
            weather: "2",
            temp_C: "15.0",
            temp_F: "59.0",
            humidity: "88",
            name: "FlipRobot",
        },
        {
            weather: "2",
            temp_C: "18.2",
            temp_F: "64.8",
            humidity: "71",
            name: "FlipRobot",
        },
        {
            weather: "1",
            temp_C: "20.6",
            temp_F: "69.1",
            humidity: "63",
            name: "FlipRobot",
        },
    ],
];

const weatherInfoHexToString = {
    65: "weather",
    66: "temp_C",
    67: "temp_F",
    68: "humidity",
    69: "rainfall",
};
const cityList = {
    "New York County": 1,
    "Taipei": 2,
    "Sydney": 3,
    "Auckland": 4,
    "Singapore": 5,
    "Kuala Lumpur": 6,
    "Shanghai": 7,
    "Beijing Municipality": 8,
};

const weatherClass = {
    Clear: "0",
    Clouds: "1",
    Mist: "1",
    Smoke: "1",
    Haze: "1",
    Dust: "1",
    Fog: "1",
    Sand: "1",
    Ash: "1",
    Rain: "2",
    Thunderstorm: "2",
    Snow: "2",
    Drizzle: "2",
    Squall: "2",
    Tornado: "2",
};

export default weather;
